import { render, staticRenderFns } from "./KurumsalHizmetler.vue?vue&type=template&id=edea1972&scoped=true&"
import script from "./KurumsalHizmetler.vue?vue&type=script&lang=js&"
export * from "./KurumsalHizmetler.vue?vue&type=script&lang=js&"
import style0 from "./KurumsalHizmetler.vue?vue&type=style&index=0&id=edea1972&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edea1972",
  null
  
)

export default component.exports